import React, { useState, useEffect } from 'react';
import { Upload, Button, Form, Input, Select, message } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import axios from 'axios';

const { Dragger } = Upload;
const { Option } = Select;

const UploadCoreEcards: React.FC = () => {
  const [CoreValues, setCoreValues] = useState<{ valueId: string, valueName: string }[]>([]);
  const [form] = Form.useForm();
  const [images, setImages] = useState<File[]>([]);
  const { instance, accounts } = useMsal();

  useEffect(() => {
    const fetchCoreValues = async () => {
      const token = await fetchToken();
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/CoreValues/ActiveWithIds`,{headers: {Authorization: `Bearer ${token}`}});
        setCoreValues(response.data);
      } catch (error) {
        console.error('Error fetching Core values:', error);
      }
    };

    fetchCoreValues();
  }, []);

   const fetchToken = async () => {
        const res = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        return res.idToken;
      };
    
      useEffect(() => {
        fetchToken();
      }, []);
  

  const handleSubmit = async (values: any) => {
    if (images.length === 0) {
      message.error('Please upload at least one image.');
      return;
    }

    for (const image of images) {
      const formData = new FormData();
      formData.append('EcardName', values.EcardName);
      formData.append('Description', values.Description || '');
      formData.append('ValueId', values.ValueId);
      formData.append('Image', image, image.name); // Ensure the file name is provided

      // Log formData entries
      Array.from(formData.entries()).forEach(([key, value]) => {
        console.log(`${key}: ${value}`);
      });

      try {
        const token = await fetchToken();
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Ecards`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        });
        message.success('Ecard uploaded successfully!');
      } catch (error) {
        console.error('Error uploading ecard:', error);
        message.error('Failed to upload ecard.');
      }
    }

    form.resetFields();
    setImages([]);
  };

  const handleMultipleUpload = async (file: File) => {
    setImages(prevImages => [...prevImages, file]);
    return false;
  };

  const uploadProps = {
    name: 'file',
    multiple: true,
    beforeUpload: handleMultipleUpload,
    onRemove: (file: any) => {
      setImages(prevImages => prevImages.filter(image => image !== file));
    },
    showUploadList: false, // Hide the upload list completely
  };

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
      <h1>Upload Core Values Ecard</h1>
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="EcardName"
          label="Ecard Name"
          rules={[{ required: true, message: 'Please enter an ecard name' }]}
        >
          <Input placeholder="Enter ecard name" />
        </Form.Item>
        <Form.Item
          name="Description"
          label="*Description"
        >
          <Input.TextArea rows={4} placeholder="Enter description" />
        </Form.Item>
        <Form.Item
          name="ValueId"
          label="Core Values"
          rules={[{ required: true, message: 'Please select a core value' }]}
        >
          <Select placeholder="Select a Core Value">
            {CoreValues.map(coreValue => (
              <Option key={coreValue.valueId} value={coreValue.valueId}>
                {coreValue.valueName}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Upload Image">
          <Dragger {...uploadProps}>
            <div>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">Click or drag file to this area to upload</p>
            </div>
          </Dragger>
          {images.length > 0 && (
            <div style={{ marginTop: '20px' }}>
              {images.map((image, index) => (
                <div key={index} style={{ position: 'relative', marginBottom: '10px' }}>
                  <img src={URL.createObjectURL(image)} alt={`Selected ${index}`} style={{ width: '100%', maxHeight: '200px', objectFit: 'contain' }} />
                  <Button
                    type="primary"
                    danger
                    style={{ position: 'absolute', top: '10px', right: '10px' }}
                    onClick={() => setImages(prevImages => prevImages.filter((_, i) => i !== index))}
                  >
                    Remove
                  </Button>
                </div>
              ))}
            </div>
          )}
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Upload All
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default UploadCoreEcards;